// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAccountBookOutlinedSvg from "@fishx/icons-svg/es/asn/PAccountBookOutlined";
import FishxIcon from '../components/FishxIcon';

var PAccountBookOutlined = function PAccountBookOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAccountBookOutlinedSvg
  }));
};

PAccountBookOutlined.displayName = 'PAccountBookOutlined';
export default React.forwardRef(PAccountBookOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAccountBookOutlined.js
// module id = 3194
// module chunks = 0